export default __webpack_public_path__ + "static/media/2_0080.d2964a1a.webp";